var _g, _path, _path2, _path3, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNodeJs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 456 284",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#699F63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.953 279.054a8.373 8.373 0 01-4.19-1.121l-13.339-7.892c-1.991-1.115-1.018-1.509-.362-1.738 2.657-.922 3.195-1.135 6.031-2.743.295-.166.687-.103.992.076l10.247 6.084c.372.206.896.206 1.237 0l39.95-23.058c.372-.212.61-.64.61-1.081v-46.103a1.29 1.29 0 00-.62-1.101l-39.933-23.038a1.25 1.25 0 00-1.231 0l-39.923 23.045a1.285 1.285 0 00-.634 1.094v46.103c0 .441.245.859.63 1.068l10.944 6.323c5.938 2.969 9.573-.528 9.573-4.041v-45.52a1.15 1.15 0 011.161-1.151h5.066c.634 0 1.158.508 1.158 1.151v45.52c0 7.925-4.316 12.47-11.829 12.47-2.309 0-4.127 0-9.202-2.501l-10.476-6.031a8.44 8.44 0 01-4.19-7.288v-46.103c0-2.995 1.602-5.792 4.19-7.281l39.95-23.085c2.528-1.43 5.888-1.43 8.396 0l39.947 23.085a8.434 8.434 0 014.196 7.281v46.103a8.457 8.457 0 01-4.196 7.288l-39.947 23.065a8.384 8.384 0 01-4.206 1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.293 247.292c-17.482 0-21.144-8.024-21.144-14.755 0-.64.514-1.151 1.155-1.151h5.165c.577 0 1.058.415 1.148.979.78 5.258 3.105 7.912 13.677 7.912 8.416 0 11.999-1.904 11.999-6.369 0-2.574-1.015-4.485-14.095-5.766-10.93-1.081-17.691-3.496-17.691-12.241 0-8.061 6.794-12.868 18.186-12.868 12.798 0 19.131 4.442 19.933 13.972.03.328-.086.644-.305.889a1.177 1.177 0 01-.846.368h-5.185a1.15 1.15 0 01-1.121-.902c-1.244-5.533-4.269-7.301-12.476-7.301-9.189 0-10.257 3.201-10.257 5.599 0 2.906 1.261 3.752 13.667 5.394 12.277 1.622 18.109 3.921 18.109 12.549-.002 8.705-7.26 13.691-19.919 13.691z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.899 198.941c0 4.236-3.463 7.699-7.699 7.699-4.197 0-7.699-3.422-7.699-7.699 0-4.359 3.586-7.701 7.699-7.701 4.156 0 7.699 3.342 7.699 7.701zm-14.155-.022c0 3.586 2.892 6.479 6.435 6.479 3.586 0 6.479-2.954 6.479-6.479 0-3.584-2.932-6.436-6.479-6.436-3.503.001-6.435 2.81-6.435 6.436zm3.563-4.297h2.976c1.018 0 3.015 0 3.015 2.282 0 1.589-1.018 1.914-1.632 2.118 1.184.082 1.264.856 1.426 1.956.083.692.206 1.874.448 2.281h-1.831c-.043-.406-.328-2.607-.328-2.728-.119-.49-.285-.733-.895-.733h-1.506v3.461h-1.672v-8.637h-.001zm1.632 3.788h1.343c1.098 0 1.304-.773 1.304-1.221 0-1.183-.816-1.183-1.264-1.183h-1.383v2.404z",
    fill: "#699F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.243 98.677a5.108 5.108 0 00-2.558-4.445L57.33 69.857a5 5 0 00-2.332-.674h-.438a5.055 5.055 0 00-2.339.674L9.866 94.232a5.132 5.132 0 00-2.561 4.445l.093 65.635c0 .912.474 1.762 1.277 2.209a2.461 2.461 0 002.541 0l25.172-14.414c1.592-.945 2.561-2.614 2.561-4.438v-30.665c0-1.828.968-3.52 2.554-4.428l10.718-6.173a5.092 5.092 0 012.564-.687c.872 0 1.768.226 2.544.687l10.715 6.173a5.1 5.1 0 012.558 4.428v30.665c0 1.824.982 3.503 2.564 4.438l25.165 14.414a2.492 2.492 0 002.558 0 2.556 2.556 0 001.271-2.209l.083-65.635zM306.04 8.451a2.564 2.564 0 00-2.543.028 2.561 2.561 0 00-1.262 2.206v65c0 .639-.342 1.231-.894 1.551-.554.32-1.237.32-1.792 0l-10.608-6.112a5.118 5.118 0 00-5.112.002l-42.372 24.453a5.115 5.115 0 00-2.559 4.43v48.916a5.12 5.12 0 002.558 4.432l42.37 24.471a5.12 5.12 0 005.118 0l42.376-24.471a5.12 5.12 0 002.558-4.432V26.989a5.117 5.117 0 00-2.624-4.469L306.04 8.451zm-3.931 124.402c0 .456-.244.879-.64 1.106l-14.548 8.386a1.282 1.282 0 01-1.277 0l-14.548-8.386a1.276 1.276 0 01-.64-1.106v-16.799c0-.456.244-.879.639-1.108l14.548-8.403a1.278 1.278 0 011.28 0l14.548 8.403c.395.229.639.652.639 1.108l-.001 16.799zM447.131 115.615a5.116 5.116 0 002.546-4.424V99.337c0-1.823-.97-3.51-2.548-4.425L405.03 70.469a5.117 5.117 0 00-5.127-.007l-42.356 24.453a5.115 5.115 0 00-2.558 4.43v48.903c0 1.839.987 3.536 2.584 4.445l42.093 23.985a5.112 5.112 0 005.017.028l25.46-14.151a2.558 2.558 0 00.031-4.455l-42.625-24.465a2.558 2.558 0 01-1.285-2.22v-15.326c0-.914.487-1.76 1.28-2.216l13.266-7.648a2.555 2.555 0 012.554 0l13.273 7.648a2.556 2.556 0 011.28 2.216v12.058a2.56 2.56 0 003.843 2.213l25.371-14.745z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M401.842 113.324a.98.98 0 01.982 0l8.13 4.69a.982.982 0 01.491.851v9.388a.982.982 0 01-.491.851l-8.13 4.69a.98.98 0 01-.982 0l-8.124-4.69a.982.982 0 01-.491-.851v-9.388c0-.352.187-.675.491-.851l8.124-4.69z",
    fill: "#699F63"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__a",
    x1: 187.702,
    x2: 149.637,
    y1: 199.285,
    y2: 121.633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3fa92d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fae2a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.12 70.717a5.086 5.086 0 00-5.087 0l-42.134 24.314a5.086 5.086 0 00-2.546 4.408v48.666c0 1.818.97 3.497 2.544 4.408l42.134 24.334a5.093 5.093 0 005.091 0l42.124-24.334a5.091 5.091 0 002.543-4.408V99.437c0-1.818-.97-3.497-2.545-4.406L173.12 70.717z",
    fill: "url(#node-js_svg__a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.12 70.717a5.086 5.086 0 00-5.087 0l-42.134 24.314a5.086 5.086 0 00-2.546 4.408v48.666c0 1.818.97 3.497 2.544 4.408l42.134 24.334a5.093 5.093 0 005.091 0l42.124-24.334a5.091 5.091 0 002.543-4.408V99.437c0-1.818-.97-3.497-2.545-4.406L173.12 70.717z",
    id: "node-js_svg__b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "node-js_svg__c"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#node-js_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#node-js_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.944 70.717l-42.222 24.314c-1.576.909-2.722 2.588-2.722 4.408v48.666c0 1.203.514 2.339 1.313 3.238l47.44-81.152a5.17 5.17 0 00-3.809.526zM171.988 177.339c.41-.113.81-.275 1.186-.492l42.177-24.334c1.574-.91 2.649-2.59 2.649-4.408V99.437c0-1.338-.598-2.598-1.54-3.534l-44.472 81.436z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__d",
    x1: 164.157,
    x2: 270.965,
    y1: 158.647,
    y2: 237.562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#41873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#54a044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#66b848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#6cc04a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.327 95.031l-42.252-24.314a5.044 5.044 0 00-1.322-.526l-47.44 81.152c.409.46.888.861 1.42 1.169l42.323 24.334a5.137 5.137 0 003.931.492l44.473-81.436a5.6 5.6 0 00-1.133-.871z",
    fill: "url(#node-js_svg__d)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.12 70.717a5.086 5.086 0 00-5.087 0l-42.134 24.314a5.086 5.086 0 00-2.546 4.408v48.666c0 1.818.97 3.497 2.544 4.408l42.134 24.334a5.093 5.093 0 005.091 0l42.124-24.334a5.091 5.091 0 002.543-4.408V99.437c0-1.818-.97-3.497-2.545-4.406L173.12 70.717z",
    id: "node-js_svg__e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "node-js_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#node-js_svg__e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#node-js_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218 148.105V99.437c0-1.818-1.098-3.497-2.673-4.406l-42.252-24.314a5.08 5.08 0 00-1.551-.571l46.317 79.128c.099-.379.159-.769.159-1.169zM125.722 95.031c-1.576.909-2.722 2.588-2.722 4.408v48.666c0 1.818 1.16 3.497 2.733 4.408l42.323 24.334a5.13 5.13 0 003.256.632l-45.337-82.594-.253.146z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__g",
    x1: 121.862,
    x2: 219.279,
    y1: 226.166,
    y2: 226.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#6cc04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#66b848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#54a044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#41873f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#node-js_svg__g)",
    d: "M166.627 61.779l-.58.331h.774z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__h",
    x1: 121.862,
    x2: 219.279,
    y1: 164.348,
    y2: 164.348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#6cc04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#66b848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#54a044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#41873f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.351 152.513c1.228-.71 2.144-1.891 2.491-3.238l-46.317-79.128a5.157 5.157 0 00-3.581.571l-41.968 24.168 45.337 82.594a5.107 5.107 0 001.861-.632l42.177-24.335z",
    fill: "url(#node-js_svg__h)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__i",
    x1: 121.862,
    x2: 219.279,
    y1: 136.537,
    y2: 136.537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#6cc04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#66b848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#54a044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#41873f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#node-js_svg__i)",
    d: "M219.279 151.73l-.279-.477v.639z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__j",
    x1: 121.862,
    x2: 219.279,
    y1: 123.968,
    y2: 123.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#6cc04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#66b848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#54a044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#41873f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.351 152.513l-42.177 24.334a5.089 5.089 0 01-1.861.632l.84 1.53L219 151.892v-.639l-1.158-1.978c-.347 1.347-1.263 2.527-2.491 3.238z",
    fill: "url(#node-js_svg__j)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "node-js_svg__k",
    x1: 233.472,
    x2: 173.391,
    y1: 201.588,
    y2: 79.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3fa92d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fae2a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.351 152.513l-42.177 24.334a5.089 5.089 0 01-1.861.632l.84 1.53L219 151.892v-.639l-1.158-1.978c-.347 1.347-1.263 2.527-2.491 3.238z",
    fill: "url(#node-js_svg__k)"
  }))))));
}

export default __webpack_public_path__ + "assets/18d3c410e059d3c15af8b03f7b5f235e.svg";
export { SvgNodeJs as ReactComponent };